import React, { useState } from "react"
import { TextArea } from "../../common/FormFields"
import OrderItem from "./OrderItem"
import "./OrderSummary.css"
import Amounts from "../common/Amounts"
import { ArrowDownIcon } from "../../common/Icons"

function OrderSummary({
  orderData,
  products,
  customProducts,
  grandTotal,
  totalWeight,
  // handleCouponChange,
  // coupon,
  customerRemarks,
  handleCustomerRemarksChange,
  deliveryData,
  customerAddress,
  customerInfo,
  tax,
  taxDetails,
  isTaxInclusive,
  discountAmount,
  subTotal,
  salesBeforeTax,
  shippingRate,
  deliveryMethodName,
  isNewOrder
}) {
  function getAddress() {
    let address = []
    if (deliveryData) {
      if (deliveryData.preferPickup) {
        const pickup = orderData.pickup_address.find(
          add => Number(add.id) === Number(deliveryData.pickUpAddress)
        )
        if (pickup) {
          pickup.address.address_line_1 &&
            address.push(pickup.address.address_line_1)
          pickup.address.address_line_2 &&
            address.push(pickup.address.address_line_2)
          pickup.address.barangay && address.push(pickup.address.barangay)
          pickup.address.city && address.push(pickup.address.city)
          pickup.address.zipcode && address.push(pickup.address.zipcode)
          pickup.address.province && address.push(pickup.address.province)
          pickup.address.country && address.push(pickup.address.country)
        }
      } else {
        if (deliveryData.toMe) {
          if (
            Object.keys(customerAddress).length > 0 &&
            customerAddress.constructor === Object
          ) {
            customerAddress.addressOne &&
              address.push(customerAddress.addressOne)
            customerAddress.addressTwo &&
              address.push(customerAddress.addressTwo)
            customerAddress.barangay &&
              customerAddress.barangay.value &&
              address.push(customerAddress.barangay.value)
            customerAddress.city &&
              customerAddress.city.value &&
              address.push(customerAddress.city.value)
            customerAddress.city &&
              !customerAddress.city.hasOwnProperty("value") &&
              address.push(customerAddress.city)
            customerAddress.zipcode && address.push(customerAddress.zipcode)
            customerAddress.state &&
              customerAddress.state.value &&
              address.push(customerAddress.state.value)
            customerAddress.country &&
              customerAddress.country.value &&
              address.push(customerAddress.country.value)
          }
        } else {
          if (
            deliveryData.hasOwnProperty("addressOne") ||
            deliveryData.hasOwnProperty("addressTwo") ||
            deliveryData.hasOwnProperty("barangay") ||
            deliveryData.hasOwnProperty("city") ||
            deliveryData.hasOwnProperty("state") ||
            deliveryData.hasOwnProperty("country") ||
            customerInfo.hasOwnProperty("zipcode")
          ) {
            deliveryData.addressOne && address.push(deliveryData.addressOne)
            deliveryData.addressTwo && address.push(deliveryData.addressTwo)
            deliveryData.barangay && address.push(deliveryData.barangay.value)
            deliveryData.city &&
              (deliveryData.city.value
                ? address.push(deliveryData.city.value)
                : address.push(deliveryData.city))
            deliveryData.zipcode && address.push(deliveryData.zipcode)
            deliveryData.state &&
              deliveryData.state.value &&
              address.push(deliveryData.state.value)
            deliveryData.country &&
              deliveryData.country.value &&
              address.push(deliveryData.country.value)
          }
        }
      }
    }
    return address
  }

  function getFullName() {
    let fullName = ""
    if (deliveryData) {
      if (!deliveryData.preferPickup) {
        if (deliveryData.toMe) {
          fullName = `${customerInfo.firstName || ""} ${customerInfo.lastName ||
            ""}`
        } else {
          fullName =
            (deliveryData &&
              deliveryData.firstName &&
              deliveryData.lastName &&
              `${deliveryData.firstName} ${deliveryData.lastName}`) ||
            ""
        }
      }
    }
    return fullName
  }

  let remarks = "default"
  if (customerRemarks) {
    if (customerRemarks.length > 250) {
      remarks = "error"
    } else {
      remarks = "is-fixed"
    }
  }
  const [expand, setExpand] = useState(false)
  function handleExpandButton() {
    setExpand(!expand)
  }

  return (
    <div className={`OrderSummary ${expand ? "expanded" : ""}`}>
      <button
        className="expand-summary"
        type="button"
        onClick={handleExpandButton}
      >
        <ArrowDownIcon />
      </button>
      <h1>Order Summary</h1>
      {/* <div className="coupon-code">
        <span>
          <label>Discount codes and coupons</label>
          <span className="capsule">
            <TextInput
              name="coupon"
              type="text"
              onChange={handleCouponChange}
              value={coupon}
            />
            <button type="button">Apply</button>
          </span>
        </span>
      </div> */}
      <div className="items hide-on-mobile">
        {products.map(product => (
          <OrderItem
            key={product.id}
            product={product}
            currency={orderData.currency}
            orderUUID={orderData.uuid}
            type="regular"
            isNewOrder={isNewOrder}
          />
        ))}
        {customProducts.map(product => (
          <OrderItem
            key={product.id}
            product={product}
            currency={orderData.currency}
            orderUUID={orderData.uuid}
            type="custom"
          />
        ))}
      </div>

      {getFullName().trim() !== "" && (
        <div className="ship-address total sub hide-on-mobile">
          <span>Ship to</span>
          {<span>{getFullName()}</span>}
          <span>
            {deliveryData &&
              !deliveryData.preferPickup &&
              getAddress().join(", ")}
          </span>
        </div>
      )}

      <Amounts
        orderData={orderData}
        totalWeight={totalWeight}
        subTotal={subTotal}
        salesBeforeTax={salesBeforeTax}
        tax={tax}
        taxDetails={taxDetails}
        discountAmount={discountAmount}
        shippingRate={shippingRate}
        deliveryMethodName={deliveryMethodName}
        isTaxInclusive={isTaxInclusive}
        customerAddress={customerAddress}
      />
      <div className={`customer-remarks ${remarks} hide-on-mobile`}>
        <label>Customer Remarks</label>
        <TextArea
          name="customer-remark"
          onChange={handleCustomerRemarksChange}
          value={customerRemarks}
          className={remarks}
        />
        {remarks === "error" && (
          <span className="error-message">
            Customer remarks must be at maximum of 255 characters.
          </span>
        )}
      </div>
    </div>
  )
}

export default OrderSummary
